import { TenantEntity } from '../TenantEntity'

export class RailwayContainerOrder extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get orderNo() {
    return this._data.orderNo
  }
  set orderNo(orderNo) {
    this._data.orderNo = orderNo
  }
  get sellerId() {
    return this._data.sellerId
  }
  set sellerId(sellerId) {
    this._data.sellerId = sellerId || 0
  }
  get sellerName() {
    return this._data.sellerName
  }
  set sellerName(sellerName) {
    this._data.sellerName = sellerName
  }
  get buyerId() {
    return this._data.buyerId
  }
  set buyerId(buyerId) {
    this._data.buyerId = buyerId || 0
  }
  get buyerName() {
    return this._data.buyerName
  }
  set buyerName(buyerName) {
    this._data.buyerName = buyerName
  }
  get currencyCode() {
    return this._data.currencyCode
  }
  set currencyCode(currencyCode) {
    this._data.currencyCode = currencyCode
  }
  get orderType() {
    return this._data.orderType
  }
  set orderType(orderType) {
    this._data.orderType = orderType || 0
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0
  }
  get ifSettlement() {
    return this._data.ifSettlement
  }
  set ifSettlement(ifSettlement) {
    this._data.ifSettlement = ifSettlement || false
  }
  get settlementDate() {
    return this._data.settlementDate
  }
  set settlementDate(settlementDate) {
    this._data.settlementDate = settlementDate
  }
  get buyerDate() {
    return this._data.buyerDate
  }
  set buyerDate(buyerDate) {
    this._data.buyerDate = buyerDate
  }
  get sellerDate() {
    return this._data.sellerDate
  }
  set sellerDate(sellerDate) {
    this._data.sellerDate = sellerDate
  }
  get rentDate() {
    return this._data.rentDate
  }
  set rentDate(rentDate) {
    this._data.rentDate = rentDate
  }
  get returnDate() {
    return this._data.returnDate
  }
  set returnDate(returnDate) {
    this._data.returnDate = returnDate
  }
}
